import React from 'react';

const OrganizationFormModal = ({
  isDialogOpen,
  editingOrganization,
  formData,
  setFormData,
  handleSubmit,
  resetForm,
}) => {
  if (!isDialogOpen) return null;

  const title = editingOrganization ? 'Editar Organización' : 'Crear Nueva Organización';

  const handleFieldChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData({ ...formData, base64_logo: reader.result as string });
      };
      reader.readAsDataURL(file);
    }
  };

  const inputClass = 'focus:ring-primary-main w-full rounded border bg-black px-3 py-2 focus:outline-none focus:ring';
  const selectClass = 'focus:ring-primary-main bg-primary-main w-full rounded border px-3 py-2 focus:ring';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 text-white">
      <div className="bg-primary-dark max-w-xl rounded p-6 shadow-lg sm:w-full max-h-[90vh] overflow-y-auto">
        <h3 className="mb-4 text-xl font-semibold">{title}</h3>
        <form onSubmit={handleSubmit} className="space-y-4 ">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

            {/* Nombre Completo */}
            <div>
              <label className="block text-sm font-medium">Nombre Completo</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleFieldChange}
                className={inputClass}
                required
              />
            </div>
            {/* Nombre Corto */}
            <div>
              <label className="block text-sm font-medium">Nombre Corto</label>
              <input
                type="text"
                name="short_name"
                value={formData.short_name}
                onChange={handleFieldChange}
                className={inputClass}
                required
              />
            </div>
            {/* OID (Identificador Único) */}
            <div>
              <label className="block text-sm font-medium">OID (Identificador)</label>
              <input
                type="text"
                name="oid"
                value={formData.oid}
                onChange={handleFieldChange}
                className={inputClass}
                required
                disabled={!!editingOrganization} // OID debe ser inmutable al editar
              />
            </div>
            {/* Código de País */}
            <div>
              <label className="block text-sm font-medium">Código de País (Ej. COL)</label>
              <input
                type="text"
                name="country_code"
                value={formData.country_code}
                onChange={handleFieldChange}
                className={inputClass}
                required
                maxLength={3}
              />
            </div>
            {/* ID de Estructura */}
            <div>
              <label className="block text-sm font-medium">ID de Estructura</label>
              <input
                type="text"
                name="structure_id"
                value={formData.structure_id}
                onChange={handleFieldChange}
                className={inputClass}
                required
              />
            </div>
            {/* Sufijo Legal */}
            <div>
              <label className="block text-sm font-medium">Sufijo Legal (Ej. SAS)</label>
              <input
                type="text"
                name="suffix"
                value={formData.suffix}
                onChange={handleFieldChange}
                className={inputClass}
                required
              />
            </div>

            {/* Estado y Logo (Filas separadas) */}
            <div className="md:col-span-2 flex items-center gap-6 pt-2">
              <label className="flex items-center space-x-2 text-sm">
                <input
                  type="checkbox"
                  name="status"
                  checked={formData.status}
                  onChange={handleFieldChange}
                />
                <span>Activa/Inactiva</span>
              </label>
            </div>

            {/* Base64 Logo (Opcional) */}
            {/* Base64 Logo (Opcional) */}
            <div className="md:col-span-2">
              <label className="block text-sm font-medium">Logotipo (Imagen)</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="block w-full text-sm text-gray-400
                  file:mr-4 file:py-2 file:px-4
                  file:rounded file:border-0
                  file:text-sm file:font-semibold
                  file:bg-blue-600 file:text-white
                  hover:file:bg-blue-700
                  cursor-pointer"
              />
              {formData.base64_logo && (
                <div className="mt-2">
                  <p className="text-xs text-gray-400 mb-1">Vista previa:</p>
                  <img
                    src={formData.base64_logo}
                    alt="Logo Preview"
                    className="h-16 object-contain border border-gray-700 p-1 bg-white"
                  />
                  <button
                    type="button"
                    onClick={() => setFormData({ ...formData, base64_logo: '' })}
                    className="mt-1 text-xs text-red-400 hover:text-red-300 underline"
                  >
                    Eliminar logo
                  </button>
                </div>
              )}
            </div>

          </div>

          <div className="flex justify-end gap-2 pt-4">
            <button
              type="button"
              onClick={resetForm}
              className="rounded bg-red-700 px-4 py-2 text-white hover:bg-red-500"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-900"
            >
              {editingOrganization ? 'Actualizar' : 'Crear'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default OrganizationFormModal;
